import { API } from "aws-amplify";

export default async function deleteCloseAccountRequest() {
  return await API.del("general-info", "/delete-close-request");
}
